import Util from '../../../Common/Util';
/**
 * ExpensePanel — 사용자PC(/u/orders) 오더 상세팝업의 경비(지출/수당/선출금) 입력·목록 패널.
 *
 * 레거시와의 관계
 * ───────────────
 * 기존 public/js/u-order-list.js 의 경비 클러스터 12함수를 캡슐화했다:
 *   showDetailList_inside / renderExpansePanel / renderExpanseForm / initExpanseFormControls /
 *   renderExpanseList / list_orderNumFromTitle / del_editJob / add_expancsemore /
 *   expase_radioTypesel / save_accountForm (+ _expEscAttr/_expEscText)
 *
 * 외부(레거시)에서 호출되는 진입점 → $j.Pages.Desktop.Orders.initialize() 가 window 로 브리지:
 *   - window.showDetailList_inside(ordernum) : show_Pop_BizForm(상세팝업 오픈) + 자체 재조회
 *   - window.save_accountForm()              : 폼 저장 버튼 onclick
 *   - window.add_expancsemore(n, md)         : 경비추가/취소 onclick + del_editJob
 *   - window.expase_radioTypesel(n, str)     : 구분(지출/수당/선출금) 라디오 onclick + del_editJob
 *   - window.del_editJob(n, num, delnum)     : 목록 수정/삭제 onclick
 *
 * ⚠ 결합 — 모듈은 strict 이므로 전부 window.* 로 접근:
 *   - list.js 잔류 : window.get_orders (저장 후 목록 갱신)
 *   - blade 전역   : window.expansess_inputtype (구분 라디오 상태)
 *   - 공통 헬퍼     : window.number_format
 *                     (지출일은 input[type=date] 로 바뀌어 Select_get_* · getMaxDay_of_month 의존이 없다)
 *   - onclick 문자열: check_typesetsSub/target_personCheck/order_relatedCheck/carPlateinput
 *                     (⚠ 저장소에 정의 없음 = 레거시 베스티지얼, 원본 동작 그대로 보존)
 *
 * 서버: GET /u/ajax/order-expense/panel · POST /u/ajax/order-expense · POST /u/ajax/orders/expense/delete
 */
export default class ExpensePanel {
    /** 상세팝업 경비 패널 로드 (구 showDetailList_inside) */
    loadPanel = (ordernum) => {
        // 레거시 user_2000_ajax_money.php get_userExpancess → /u/ajax/order-expense/panel (JSON+JS 렌더)
        $.ajax({
            type: "GET", url: "/u/ajax/order-expense/panel", data: { "orderNum": ordernum }, dataType: "json",
            success: (data) => {
                this._renderPanel(data);
            }
        });
    }

    // 지출 패널(입력폼+목록) 렌더 — 레거시 get_input_expanceJob + make_userExpancess
    _renderPanel = (data) => {
        var obj = document.getElementById("expanceInBox");
        if (!obj) return;
        obj.innerHTML = this._renderForm(data.form) + this._renderList(data.list);
        this._initFormControls(data.form);
    }

    _escAttr = (v) => { return String(v == null ? "" : v).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;"); }
    _escText = (v) => { return String(v == null ? "" : v).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"); }

    _renderForm = (form) => {
        if (!form) return "";
        var chImg = function (on) { return on ? "checkbox_box_20_on" : "checkbox_box_20"; };
        var isExp = form.inputType == "지출항목", isSu = form.inputType == "수당", isSun = form.inputType == "선출금";
        // 내용(typemain) 옵션 — 선택된 구분의 sub 목록
        var defOption = "<option value=''>지출,수당,선출금 중 선택해 주세요</option>";
        if (form.inputType && form.types && form.types[form.inputType]) {
            form.types[form.inputType].forEach((sub) => {
                defOption += "<option value='" + this._escAttr(sub) + "'" + (sub == form.inputTypeSub ? " selected" : "") + ">" + this._escText(sub) + "</option>";
            });
        }
        // 기사 옵션
        var driverOpt = (form.drivers && form.drivers.length > 1) ? "<option value=''>기사선택</option>" : "";
        (form.drivers || []).forEach((d) => { driverOpt += "<option value='" + d.num + "'>" + this._escText(d.name) + "</option>"; });
        // 오더 옵션 (레거시: 선택된 오더만)
        var orderOpt = "";
        (form.orders || []).forEach((o) => { orderOpt += "<option value='" + o.num + "' selected>" + this._escText(o.label) + "</option>"; });
        // 차량 옵션
        var carOpt = "<option value='0'>차량관련외 입력</option>";
        (form.cars || []).forEach((c) => { carOpt += "<option value='" + c.num + "'" + (c.selected ? " selected" : "") + ">" + this._escText(c.plate) + "</option>"; });
        // 구분별 sub 목록 (radio 전환용)
        var memset = function (k) { return (form.types && form.types[k]) ? form.types[k].join("|") : ""; };
        var enab = form.dateEnabled ? "" : "disabled=true";

        var todayStr = (new Date()).toISOString().slice(0, 10);
        var h = ""
            + "<style>"
            + ".accountsetindiv{display:inline;font-weight:bold}"
            + ".accountset_table{width:97%;border-spacing:0px;padding:0px;border-collapse:collapse;margin:0px auto}"
            + ".accountset_table th{font-weight:bold;text-align:right;padding-right:5px;height:33px;border-bottom:1px solid #C0C0C0}"
            + ".accountset_table td{font-weight:bold;text-align:left;padding-left:5px;border-bottom:1px solid #C0C0C0}"
            + ".aradio{width:15px;height:15px}"
            + ".accountset_table>tbody>tr>td select{border:1px solid #e1e2e3;border-radius:0;background:#fff;width:100%;height:28px;line-height:28px;font-weight:bolder}"
            + "</style>"
            + "<div style=\"width:400px;margin:0px auto;border:1px solid #000000;padding:10px;border-radius:6px;border:2px solid #000000;display:none\" id=\"expansemoreinDiv\">"
            + "<table width=\"100%\" border=\"0\" cellspacing=\"0\" cellpadding=\"0\" class=\"accountset_table\"><colgroup><col style=\"width:80px\"><col style=\"width:*\"></colgroup><tbody>"
            + "<tr><th scope=\"row\" style=\"background-color:#C1DEFD\">구분</th>"
            + "<td style=\"background-color:#C1DEFD;line-height:25px;white-space:nowrap;margin-top:5px\"><div style=\"width:100%;position:relative;top:4px;text-align:center\">"
            + "<a href=\"javascript:expase_radioTypesel(1,'지출항목')\"><img src=\"/img/" + chImg(isExp) + ".png\" id=\"radio_inputtype1\"><span style=\"position:relative;top:-5px;color:#000000\">기사 지출 &nbsp;</span></a>"
            + "<a href=\"javascript:expase_radioTypesel(2,'수당')\"><img src=\"/img/" + chImg(isSu) + ".png\" id=\"radio_inputtype2\"><span style=\"position:relative;top:-5px;color:#000000\">기사 수당 &nbsp;</span>"
            + "<a href=\"javascript:expase_radioTypesel(3,'선출금')\"><img src=\"/img/" + chImg(isSun) + ".png\" id=\"radio_inputtype3\"><span style=\"position:relative;top:-5px;color:#000000\">기사 선출금 &nbsp;</span>"
            + "</div></td></tr>"
            // 지출일 — 예전엔 년/월/일 <select> 3칸이었다(Select_get_* 로 채웠다).
            // 브라우저 기본 날짜입력이 말일·윤년까지 알아서 막아 줘서 검증도 함께 사라졌다.
            + "<tr><th scope=\"row\">지출일</th><td><input type=\"date\" id=\"occureDate\" " + enab + " style=\"width:150px;height:30px\"></td></tr>"
            + "<tr><th scope=\"row\">내용</th><td id=\"userexpanceinputHolder\"><select name=\"typemain\" id=\"typemain\" style=\"width:100%\" onchange=\"check_typesetsSub(this)\">" + defOption + "</select></td></tr>"
            + "<tr><th scope=\"row\">기사</th><td><select name=\"selectdirver\" id=\"selectdirver\" onchange=\"target_personCheck(this)\">" + driverOpt + "</select></td></tr>"
            + "<tr><th scope=\"row\">오더</th><td><select name=\"selectorder\" id=\"selectorder\" onchange=\"order_relatedCheck(this)\">" + orderOpt + "</select></td></tr>"
            + "<tr><th scope=\"row\">차량</th><td><select name=\"selectcar\" id=\"selectcar\" onchange=\"carPlateinput()\">" + carOpt + "</select></td></tr>"
            + "<tr><th scope=\"row\">금액</th><td style=\"border:1px solid #F1F1F1\"><input type=\"tel\" name=\"jobprice\" id=\"jobprice\" style=\"width:100%;-webkit-appearance:none;border:1px solid #bcbcbc;height:25px;font-weight:bold;color:red\" placeHolder=\"입금액 숫자만으로\" value=\"" + (form.price ? Util.formatNumber(form.price) : "") + "\"></td></tr>"
            + "<tr><th scope=\"row\">비고</th><td><input type=\"text\" name=\"jobetc\" id=\"jobetc\" style=\"width:100%;-webkit-appearance:none;border:1px solid #bcbcbc;height:25px\" value=\"" + this._escAttr(form.memo) + "\"></td></tr>"
            + "<input type=\"hidden\" name=\"inputtype\" id=\"inputtype\" value=\"" + this._escAttr(form.inputType) + "\" style=\"width:50px\">"
            + "</tbody></table>"
            + "<div style=\"width:100%;height:10px\">&nbsp;</div>"
            + "<div class=\"chkBtnBox clfix marT30\" style=\"width:85%;text-align:center;margin:0px auto\">"
            + "<input type=\"button\" value=\"" + this._escAttr(form.btnLabel) + "\" style=\"width:60px;height:25px;line-height:25px;border:1px solid #000000;background-color:#407FB5;color:#FFFFFF\" id=\"expansesaveBtn1\" class='acBtn' onclick=\"save_accountForm()\">"
            + "<input type=\"button\" value=\"취소\" style=\"width:60px;height:25px;line-height:25px;border:1px solid #000000\" onclick=\"add_expancsemore(-1)\" class='acBtn'>"
            + "<input type=\"hidden\" id=\"memsetType1\" value=\"" + this._escAttr(memset('지출항목')) + "\">"
            + "<input type=\"hidden\" id=\"memsetType2\" value=\"" + this._escAttr(memset('수당')) + "\">"
            + "<input type=\"hidden\" id=\"expance_mine\" value=\"0\">"
            + "<input type=\"hidden\" id=\"memsetType3\" value=\"" + this._escAttr(memset('선출금')) + "\">"
            + "<input type=\"hidden\" name=\"inputdate\" id=\"inputdate\" value=\"" + todayStr + "\">"
            + "<input type=\"hidden\" name=\"mynum\" id=\"mynum\" value=\"" + form.ownerNum + "\">"
            + "<input type=\"hidden\" id=\"select_bankbookname\" name=\"select_bankbookname\" value=\"\">"
            + "<input type=\"hidden\" id=\"select_drivername\" name=\"select_drivername\" value=\"\">"
            + "<input type=\"hidden\" id=\"select_drivernum\" name=\"select_drivernum\" value=\"\">"
            + "<input type=\"hidden\" id=\"select_carplatetext\" name=\"select_carplatetext\" value=\"" + this._escAttr(form.workerCarplate) + "\">"
            + "<input type=\"hidden\" id=\"inputmemtype\" name=\"inputmemtype\" value=\"소유자\">"
            + "<input type=\"hidden\" id=\"mem_ownercode\" name=\"mem_ownercode\" value=\"" + form.ownerNum + "\">"
            + "<input type=\"hidden\" name=\"datatype\" id=\"datatype\" value=\"사업\">"
            + "<input type=\"hidden\" name=\"regfromtype\" id=\"regfromtype\" value=\"pc2000\">"
            + "<input type=\"hidden\" name=\"expanseeditnum\" id=\"expanseeditnum\" value=\"" + form.editNum + "\">"
            + "<input type=\"hidden\" name=\"regto_order\" id=\"regto_order\" value=\"" + form.regToOrder + "\">"
            + "</div><div style=\"width:100%;height:10px\">&nbsp;</div></div>";
        return h;
    }

    // 렌더 후 지출일 채우기 (input[type=date] 는 YYYY-MM-DD 만 받는다)
    _initFormControls = (form) => {
        if (!form) return;
        $j.Common.Form.registerNumberHandler("jobprice");   // 금액칸 컴마 자동
        var el = document.getElementById("occureDate");
        if (!el) return;
        el.value = form.date.year + "-" + Util.pad(form.date.month, 2) + "-" + Util.pad(form.date.day, 2);
    }

    _renderList = (list) => {
        if (!list) return "";
        var ffst = " style='font-weight:bold;color:#000000;text-align:center;white-space:nowrap;border-collapse:collapse;overflow:hidden'";
        var ffst2 = " style='font-weight:bold;color:#000000;text-align:left;white-space:nowrap;border-collapse:collapse;overflow:hidden'";
        var h = "<div style='width:98%;height:30px;text-align:right;line-height:30px;margin:0px auto'>"
            + "<div style='display:inline-block;float:left;padding-left:3px;font-weight:bolder'>" + this._escText(list.title) + "</div>"
            + "<div style='display:inline-block;float:right;padding-right:2px;'><font style='font-weight:bolder;color:black'>"
            + "<input type='button' value='경비추가' class='acBtn' style='width:80px;height:25px;line-height:25px;border:1px solid #000000' onclick='add_expancsemore(1)'>"
            + "</font></div></div>"
            + "<div style='width:100%; height:5px; clear:both'></div>"
            + "<table style='width:99%;border-collapse:collapse;margin:0px auto;table-layout:fixed;' border=1><colgroup>"
            + "<col style='width:60px'/><col style='width:*'/><col style='width:100px'/><col style='width:60px'/><col style='width:60px'/><col style='width:60px'/><col style='width:60px'/><col style='width:95px'/></colgroup>"
            + "<tr style='background-color:#A6A6D2;font-weight:bolder;height:25px'>"
            + "<td style='height:25px;text-align:center;color:#FFFFFF;'>날짜</td><td style='height:25px;text-align:center;color:#FFFFFF;'>현장</td>"
            + "<td style='height:25px;text-align:center;color:#FFFFFF;'>메모</td><td style='height:25px;text-align:center;color:#FFFFFF;'>구분</td>"
            + "<td style='height:25px;text-align:center;color:#FFFFFF;'>내용</td><td style='height:25px;text-align:center;color:#FFFFFF;'>금액</td>"
            + "<td style='height:25px;text-align:center;color:#FFFFFF;'>자비</td><td style='height:25px;text-align:center;color:#FFFFFF;'>설정</td></tr>";
        (list.rows || []).forEach((r) => {
            var mainType = String(r.main_type || "").trim();
            var typeNum = 1; if (mainType == "수당") typeNum = 2; if (mainType == "선출금") typeNum = 3;
            var wd = String(r.work_date || "").split("-");
            var isOnMe = r.expance_isonme == 1 ? "<font color=red>Yes</font>" : "No";
            var pipe = [typeNum, r.main_type, r.sub_type, r.c_price, r.ref_ordernum, r.driver_num, r.ref_carnum, r.etc_memo, wd[0], wd[1], wd[2], r.expance_isonme].join("|");
            h += "<tr style='height:30px;line-height:30px'>"
                + "<td " + ffst + ">" + this._escText(String(r.work_date || "").substr(5, 10)) + "</td>"
                + "<td " + ffst2 + ">" + this._escText(r.site_address) + "</td>"
                + "<td " + ffst2 + ">" + this._escText(r.etc_memo) + "</td>"
                + "<td " + ffst + ">" + this._escText(String(r.main_type || "").replace("지출항목", "지출")) + "</td>"
                + "<td " + ffst + ">" + this._escText(r.sub_type) + "</td>"
                + "<td " + ffst + ">" + Util.formatNumber(r.c_price) + "</td>"
                + "<td " + ffst + ">" + isOnMe + "</td>"
                + "<td " + ffst + "><input type='button' value='수정' style='width:35px;height:25px' onclick='del_editJob(1," + r.num + ")' class='acBtn'>&nbsp;"
                + "<input type='button' value='삭제' style='width:35px;height:25px' onclick='del_editJob(0," + r.num + "," + this._orderNumFromTitle(list) + ")' class='acBtn'>"
                + "<input type='hidden' id='expanseealine_" + r.num + "' value=\"" + this._escAttr(pipe) + "\"></td></tr>";
        });
        h += "<tr style='height:25px'><td colspan=7 " + ffst + ">총계</td><td " + ffst + "><font style='color:red'>" + Util.formatNumber(list.total) + "</font></td></table>";
        return h;
    }

    // 목록 title "오더번호 [N] 의 ..." 에서 오더번호 추출 (삭제시 재조회용)
    _orderNumFromTitle = (list) => {
        var m = String(list.title || "").match(/\[(\d+)\]/);
        return m ? m[1] : 0;
    }

    // 경비 수정(n=1)/삭제(n=0) (구 del_editJob)
    editOrDelete = (n, ordernum, deleteordernum) => {
        if (n == 2) {
            return;
        }
        if (n == 0) {
            var sendData = { "ordernum": deleteordernum, "editNum": ordernum };
            var adr = "/u/ajax/orders/expense/delete";
            if (confirm("선택한 경비를 삭제할까요?")) {
                $.ajax({
                    type: "POST", url: adr, data: sendData, success: (data) => {
                        this.loadPanel(deleteordernum);
                    }
                });
            }
            return;
        }
        if (n != 1) return;
        var obj = document.getElementById("expanseealine_" + ordernum);
        if (!obj) return;
        var conts = obj.value.split("|");
        this.toggleForm(1, 'edit');

        this.selectType(conts[0], conts[1]);
        // conts[8..10] 은 work_date 를 '-' 로 쪼갠 값이라 이미 YYYY / MM / DD 다
        document.getElementById("occureDate").value = [conts[8], conts[9], conts[10]].join("-");
        document.getElementById("selectdirver").value = conts[5];

        document.getElementById("selectorder").value = conts[4];
        document.getElementById("selectcar").value = conts[6];

        document.getElementById("jobprice").value = conts[3];
        document.getElementById("jobetc").value = conts[7];

        document.getElementById("expanseeditnum").value = ordernum;

        document.getElementById("typemain").value = conts[2];
        var obj2 = document.getElementById("expances_minset");
        if (obj2) {
            var cx = parseInt(conts[11]);
            if (isNaN(cx)) cx = 0;
            if (cx == 1) obj2.checked = true;
        }
    }

    // 입력폼 열기/닫기 (구 add_expancsemore)
    toggleForm = (n, md) => {
        document.getElementById("expanseeditnum").value = 0;
        n == 1 ? $("#expansemoreinDiv").slideDown() : $("#expansemoreinDiv").slideUp();
        md == "edit" ? document.getElementById("expansesaveBtn1").value = "수정" : document.getElementById("expansesaveBtn1").value = "추가";
    }

    // 구분(지출/수당/선출금) 라디오 선택 → 내용 select 갱신 (구 expase_radioTypesel)
    selectType = (n, str) => {
        window.expansess_inputtype = n;
        document.getElementById("inputtype").value = str;
        var strs = document.getElementById("memsetType" + n).value;
        var sel_ww = 100;
        var selOpts = "";
        window.expansess_inputtype == 1 ? document.getElementById("radio_inputtype1").src = "/img/checkbox_box_20_on.png" : document.getElementById("radio_inputtype1").src = "/img/checkbox_box_20.png";
        window.expansess_inputtype == 2 ? document.getElementById("radio_inputtype2").src = "/img/checkbox_box_20_on.png" : document.getElementById("radio_inputtype2").src = "/img/checkbox_box_20.png";
        window.expansess_inputtype == 3 ? document.getElementById("radio_inputtype3").src = "/img/checkbox_box_20_on.png" : document.getElementById("radio_inputtype3").src = "/img/checkbox_box_20.png";
        if (window.expansess_inputtype == 1) {
            sel_ww = 50;
            selOpts = "&nbsp;&nbsp;<input type='checkbox' id='expances_minset' value='1'>자비지출";
        }
        var selStrs = "<select name='typemain' id='typemain' style='width:" + sel_ww + "%;color:red'><option value='' style='color:red'>선택</option>";
        var opts = strs.split("|");
        for (var i = 0; i < opts.length; i++) {
            if (opts[i].length > 1) {
                selStrs += "<option value='" + opts[i] + "'>" + opts[i] + "</option>";
            }
        }
        selStrs += "</select>";
        document.getElementById("userexpanceinputHolder").innerHTML = selStrs + selOpts;
    }

    /** 경비내역 저장 (구 save_accountForm) */
    save = () => {
        var inoutsel = document.getElementById("inputtype").value;
        var typemain = document.getElementById("typemain").value;
        var selectdirver = parseInt(document.getElementById("selectdirver").value, 10);
        var selectorder = parseInt(document.getElementById("selectorder").value, 10);
        var selectcar = parseInt(document.getElementById("selectcar").value, 10);
        var jobprice = document.getElementById("jobprice").value.replace(/,/gi, "");
        jobprice = parseInt(jobprice, 10);
        var jobetc = document.getElementById("jobetc").value;
        jobetc = jobetc.replace(/'/gi, "");
        var mynum = document.getElementById("mynum").value;
        var select_drivername = document.getElementById("select_drivername").value;
        var select_drivernum = document.getElementById("select_drivernum").value;
        var select_carplatetext = document.getElementById("select_carplatetext").value;
        var inputmemtype = document.getElementById("inputmemtype").value;
        var mem_ownercode = document.getElementById("mem_ownercode").value;
        var datatype = document.getElementById("datatype").value;
        var expanseeditnum = parseInt(document.getElementById("expanseeditnum").value, 10);
        var regto_order = parseInt(document.getElementById("regto_order").value, 10);
        if (isNaN(regto_order)) { alert("연결된 오더값이 없습니다."); return; }

        // input[type=date] 가 YYYY-MM-DD 를 그대로 준다. 말일·윤년 검증은 브라우저 몫이라
        // 예전의 년/월/일 3단 검증과 getMaxDay_of_month 비교가 필요 없어졌다.
        var work_datevalue = document.getElementById("occureDate").value;
        if (!work_datevalue) { alert("지출일을 선택해 주세요"); return; }
        if (isNaN(jobprice)) jobprice = 0;
        if (isNaN(selectdirver)) selectdirver = 0;
        if (isNaN(selectcar)) selectcar = 0;
        if (inoutsel == "" || inoutsel == "0") { alert("구분을\n[지출, 수당, 선출금]중\n선택해 주세요"); return; }
        if (typemain == "") { alert("내용을 선택해 주세요"); return; }
        if (selectdirver == 0) { alert("기사를 선택해 주세요"); return; }
        if (isNaN(selectorder)) { alert("금액이 입출금이 발생된 오더를 선택해 주세요"); return; }
        if (jobprice == 0) { alert("금액을 입력해 주세요"); return; }
        if (typemain == "") { alert("지출 항목 내용을 선택해 주세요"); return; }
        var expace_isonme = 0;
        if (document.getElementById("expances_minset")) {
            if (document.getElementById("expances_minset").checked == true) expace_isonme = 1;
        }
        var sendData = {};
        sendData["jobtype"] = "save_expansess";
        sendData["inoutsel"] = inoutsel;
        sendData["expanseeditnum"] = expanseeditnum;
        sendData["typemain"] = typemain;
        sendData["selectdirver"] = selectdirver;
        sendData["selectorder"] = selectorder;
        sendData["selectcar"] = selectcar;
        sendData["jobprice"] = jobprice;
        sendData["jobetc"] = jobetc;
        sendData["mynum"] = mynum;
        sendData["expace_isonme"] = expace_isonme;
        sendData["regto_order"] = regto_order;
        sendData["select_drivername"] = select_drivername;
        sendData["select_drivernum"] = select_drivernum;
        sendData["select_carplatetext"] = select_carplatetext;
        sendData["inputmemtype"] = inputmemtype;
        sendData["mem_ownercode"] = mem_ownercode;
        sendData["datatype"] = datatype;
        sendData["work_datevalue"] = work_datevalue;
        sendData["regfromtype"] = "app3000";

        sendData["orderOnly"] = "orderOnly";
        sendData["orderNum"] = selectorder;
        sendData["showmode"] = "inbox";
        // 레거시 user_2000_ajax_money.php save_expansess → POST /u/ajax/order-expense (저장 후 패널 JSON 반환)
        $.ajax({
            type: 'POST', url: "/u/ajax/order-expense", data: sendData, dataType: "json",
            success: (data) => {
                if (data && data.ok === false) { alert(data.error || "저장에 실패했습니다."); return; }
                this._renderPanel(data);
                window.get_orders();
            }
        });
    }
}
